/* eslint-disable max-lines-per-function */
import { FieldBase } from '@/domain/mitarbeiter/shared/components/form/fieldComponents/FieldBase';
import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import { useAnlageassistentContext } from '@/domain/mitarbeiter/features/anlageassistent/context/useAnlageassistentContext';
import {
  anstellungstyp,
  Anstellungstyp,
} from '@/domain/mitarbeiter/features/anlageassistent/utils/constants/anstellungstyp';
import {
  Body,
  FieldLabel,
  Heading,
  Select,
  SelectClearItem,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
  Separator,
  Switch,
  Title,
} from '@e2n/ui/v2';
import { useTranslation } from 'react-i18next';

export function Anstellung() {
  const { ctx } = useAnlageassistentContext();
  const form = useAnlageassistentFormContext();
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-6">
      <div className="flex flex-col gap-3">
        <Heading>{ctx.getCurrentSubStep()?.title}</Heading>
        <Body>
          {t(
            'domain.mitarbeiter.create.steps.anstellungsverhaeltnis.anstellung.description',
          )}
        </Body>
      </div>

      <div className="grid md:grid-cols-2 grid-cols-1 gap-4 items-start">
        <form.AppField name="anstellungsverhaeltnis.anstellung.anstellungstyp">
          {(field) => (
            <FieldBase
              isRequired
              label={t(
                'domain.mitarbeiter.create.steps.anstellungsverhaeltnis.anstellung.form.anstellungstyp.label',
              )}>
              <Select
                onValueChange={(val) =>
                  field.handleChange(val as Anstellungstyp)
                }
                value={field.state.value ?? ''}>
                <SelectTrigger
                  id={field.name}
                  onBlur={field.handleBlur}
                  className="border-neutrals-400">
                  <SelectValue
                    placeholder={t(
                      'domain.mitarbeiter.create.steps.anstellungsverhaeltnis.anstellung.form.anstellungstyp.placeholder',
                    )}
                  />
                </SelectTrigger>
                <SelectContent className="max-h-44 overflow-y-scroll">
                  <SelectClearItem onClick={() => field.handleChange(null)}>
                    {t('actions.resetItem')}
                  </SelectClearItem>

                  {Object.keys(anstellungstyp).map((anstellungstyp) => (
                    <SelectItem
                      key={anstellungstyp}
                      value={anstellungstyp}
                      className="p-2">
                      {t(
                        `domain.mitarbeiter.create.steps.anstellungsverhaeltnis.anstellung.form.anstellungstyp.options.${anstellungstyp}`,
                      )}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </FieldBase>
          )}
        </form.AppField>
        <form.AppField name="anstellungsverhaeltnis.anstellung.eintrittsdatum">
          {(field) => (
            <field.DatePickerInput
              isRequired
              infoText={t(
                'domain.mitarbeiter.create.steps.anstellungsverhaeltnis.anstellung.form.eintrittsdatum.info',
              )}

              label={t(
                'domain.mitarbeiter.create.steps.anstellungsverhaeltnis.anstellung.form.eintrittsdatum.label',
              )}
            />
          )}
        </form.AppField>
      </div>
      <Separator />
      <div className="grid md:grid-cols-2 grid-cols-1 gap-4 items-start">
        <div className="flex flex-col gap-4 col-span-2">
          <Title>
            {t(
              'domain.mitarbeiter.create.steps.anstellungsverhaeltnis.anstellung.form.befristung.label',
            )}
          </Title>

          <form.Field
            name="anstellungsverhaeltnis.anstellung.befristet"
            listeners={{
              onChange: () => {
                ctx.resetDependentFields(
                  'anstellungsverhaeltnis.anstellung.befristet',
                );
              },
            }}>
            {(field) => (
              <div className="flex items-center space-x-2">
                <Switch
                  id="befristungToggle"
                  checked={field.state.value}
                  onCheckedChange={field.handleChange}
                />
                <FieldLabel
                  htmlFor="befristungToggle"
                  className="text-neutrals-900 text-sm font-normal leading-5">
                  {t(
                    'domain.mitarbeiter.create.steps.anstellungsverhaeltnis.anstellung.form.befristung.description',
                  )}
                </FieldLabel>
              </div>
            )}
          </form.Field>
        </div>
        <form.Subscribe
          selector={(state) =>
            state.values.anstellungsverhaeltnis.anstellung.befristet
          }>
          {(befristet) =>
            befristet && (
              <form.AppField name="anstellungsverhaeltnis.anstellung.befristung">
                {(field) => (
                  <field.DatePickerInput
                    label={t(
                      'domain.mitarbeiter.create.steps.anstellungsverhaeltnis.anstellung.form.befristetBis.label',
                    )}
                    isRequired
                  />
                )}
              </form.AppField>
            )
          }
        </form.Subscribe>
      </div>
    </div>
  );
}
